import "./banner"
import "./blog"
import Mock from 'mockjs'

Mock.setup({
  timeout: '100-300'
})